var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"slide-wrapper"},[_c('Padder',[_c('span',{staticClass:"slide-name"},[_vm._v(_vm._s(_vm.slide))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }